<template>
  <div class="block-promo">
    <div class="container">
      <div class="block-promo__inner">
        <div>
          <div class="block-promo__title">
            ФИНАЛЬНАЯ АКЦИЯ НА MITSUBISHI
          </div>
          <div class="block-promo__comment">
            ТОЛЬКО 3 ДНЯ В РОЛЬФ ПОСЛЕДНИЕ АВТОМОБИЛИ ПО АКЦИИ
          </div>
        </div>

        <div class="block-promo__button-wrapper">
          <button
            class="btn btn-red block-promo__button"
            @click="() => $emit('call-order', { title1: 'Получить предложение' })"
          >Получить предложение</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import promoData from "../common/promo-data";

export default {
  name: "promo-block",
  data() {
    return {
      promoData,
    };
  },
  methods: {
    getOffer(title) {
      this.$emit("call-order", title);
    },
  },
};
</script>

<style lang="scss" scoped>
.line-through {
  text-decoration: line-through;
}

.block-promo {
  background: white url("../img/background/bg-new.jpg") no-repeat;
  background-position-y: 45%;
  background-position-x: 60%;
  position: relative;
  height: 700px;

  @media (max-width: 1250px) {
    height: 600px;
    background-size: auto 600px;
  }

  @media (max-width: 767px) {
    background: white url("../img/background/bg-new-mobile.jpg") no-repeat;
    background-size: 100%;
    background-position-y: top;
    height: 120vw;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    // background: white top no-repeat;
    background-size: 160%;
  }

  &__btn--transparent {
    @media (min-width: 767px) and (max-width: 991px) {
      color: #fff;

      background-color: #a8a8a8;
    }

    &:hover {
        background: #686d71;
        border-color: #686d71;
        color: #fff;
    }
  }
}

.container {
  margin: 0px auto;
  max-width: 1240px;
  position: relative;
  padding: 0px 15px;
  text-align: center;
  height: 100%;
}

.btn.transgray {
  background: transparent;
  border-color: #a8a8a8;
  color: #a8a8a8;

  &:hover {
    border-color: #cdcdcd;
    color: #cdcdcd;
  }
}

.block-promo__button-wrapper {
  display: flex;
  justify-content: center;
}

.block-promo__button {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  padding: 25px 15px;
}

.block-promo__inner {
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 767px) {
    justify-content: space-between;
    padding-bottom: 30px;
  }
}

.block-promo__title {
  color: white;
  font-size: 50px;
  font-weight: 700;
  padding-top: 20px;
  padding-bottom: 0;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);

  @media (max-width: 767px) {
    text-align: center;
    font-size: 43px;
    font-weight: 700;
    padding-bottom: 20px;

    br {
      display: none;
    }
  }
  @media (max-width: 500px) {
    font-size: 35px;
  }
  @media (max-width: 380px) {
    font-size: 28px;
  }
}

.block-promo__comment {
  color: white;
  font-size: 26px;
  font-weight: 700;
  padding-bottom: 32px;
  // text-align: left;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.7);



  @media (max-width: 767px) {
    text-align: center;
    padding: 0 10%;
  }

  @media (max-width: 500px) {
    font-size: 20px;
  }

  @media (max-width: 380px) {
    font-size: 15px;
  }
}

.block-promo__comment span {
  font-size: 35px;
}


</style>
